import { back } from '../../../helpers/dataServer';

export const API_PRODUCTS_BUY = `${back}/productos/buy`;
export const API_CONDITION_FISCAL = `${back}/condicionfiscal/`;
export const API_COD_POSTAL = `${back}/params/codpostal/`;
export const API_SEND_PURCHASE = `${back}/sendpurchase/`;
export const API_DUPLICATE = `productos/duplicate/`;
